// extracted by mini-css-extract-plugin
export default {"HomeMobile":"HomeMobile_HomeMobile__GcZgK","CreateStudyGroupMiniWidget":"HomeMobile_CreateStudyGroupMiniWidget__trGNh"};